import React, { useEffect, useRef, useState } from 'react'
import { useParams } from "react-router-dom";
import { getNodeHeight, getTitle, timeColors, toEighths } from '../Editor/utils/sceneutils';
import SceneDetailsSlider from './SceneDetailsSlider';
import { GoDotFill } from "react-icons/go";
import EmptyPage from '../Editor/sidepanel/EmptyPage';
import { getAccessToken } from '../../../services/authService';
import LoaderSpin from '../../Common/LoaderSpin';
import { getPNodeArrtibute } from '../ScriptInfo/functions';
import { PADDING, PAGE_HEIGHT } from '../Editor/utils/pageUtils';
import { exportContentStyle } from '../Editor/utils/exportUtils';

const ScenesTab = ({ setUpdateData, body, scriptData, searchVal }) => {
    const [activeScene, setActiveScene] = useState(null)
    const [activeIndex, setActiveIndex] = useState(null)
    const measuringContainer = useRef(null)

    const userData = JSON.parse(localStorage.getItem("user"));
    const [users, setUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const { id } = useParams();
    const [permissionToEdit, setPermissionToEdit] = useState(false);

    useEffect(() => {
        if (users.length === 0) fetchCollaborator();
    }, []);

    const fetchCollaborator = async () => {
        setIsLoading(true);
        const token = getAccessToken();
        try {
            const response = await fetch(
                `${process.env.REACT_APP_DEV_API}/documents/${id}/invites`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            setIsLoading(false);
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }

            const data = await response.json();
            setUsers(data.data);
            const isAdmin = !data.data.find(user => user.invitedUserEmail === userData.email);
            const allowedToEdit = isAdmin || data.data.find(user => user.invitedUserEmail === userData.email)?.permission?.SCRIPT === "WRITE";
            setPermissionToEdit(allowedToEdit);
        } catch (error) {
            console.error("There was a problem with the fetch operation:", error);
        }
    };

    const createMeasuringContainer = () => {
        const container = document.createElement('pdfupload');

        container.className = 'pdf-container'


        container.style.cssText = `
            position: absolute;
            visibility: hidden;
            display:block;
            width:794.993px;
            z-index:100;
            top: -9999px;
            left: -9999px;
            box-sizing: border-box;
        `

        body.childNodes.forEach(node => {
            if (node.nodeType === 1) {
                const cloneNode = node.cloneNode(true)
                container.appendChild(cloneNode)
            }

        })

        const styles = document.createElement('style');
        styles.innerHTML = exportContentStyle;
        container.prepend(styles);
        document.body.appendChild(container);
        measuringContainer.current = container
    };

    const scenes = []
    let sceneIndex = 0
    let sceneHeight = 0

    if (!measuringContainer.current) {
        createMeasuringContainer()
    }

    measuringContainer.current.childNodes.forEach((node, index) => {
        if (node.nodeType === 1 && node.nodeName !== 'STYLE') {
            if (node.classList[0] !== "custom-pagebreak") {
                sceneHeight += getNodeHeight(node)

            }

            if (sceneIndex > 0 && index === measuringContainer.current.childNodes.length - 1) {
                scenes[sceneIndex - 1].sceneHeight = toEighths(sceneHeight / PAGE_HEIGHT)
            }

            if (node.classList[0] === 'sceneHeadings') {
                scenes.push({
                    color: node.getAttribute('data-color'),
                    summary: node.getAttribute('data-summary'),
                    title: node.textContent,
                    notes: 0,
                    sceneHeight: '1/8'
                })
                
                if (sceneIndex > 0) {
                    scenes[sceneIndex - 1].sceneHeight = toEighths(sceneHeight / PAGE_HEIGHT)
                }
                sceneHeight = 0
                sceneIndex++
            }



            if (scenes[sceneIndex - 1] && node.getAttribute("data-note-list")) {
                const noteList = JSON.parse(node.getAttribute("data-note-list") || "null") || []
                scenes[sceneIndex - 1].notes += noteList.length
            }


        }

    })

    if (measuringContainer.current) {
        measuringContainer.current.remove()
    }

    const [sceneList, setSceneList] = useState(scenes)

    const filteredList = sceneList.slice().map((scene, index) => { return { ...scene, index: index + 1 } }).
        filter(({ title }, index) => title.toUpperCase().includes(searchVal.toUpperCase()) || index + 1 == searchVal);

    if (isLoading) {
        return (
            <div className="flex w-full justify-center items-center h-[80vh]">
                <LoaderSpin size={36} />
            </div>
        )
    }

    return (
        <>
            {!sceneList || sceneList.length === 0 ? <EmptyPage title={'You do not have any scenes'} subtitle={'Create some scenes to see here'} />
                :
                <>
                    <div className='mt-4'>
                        {!filteredList || filteredList.length === 0 &&
                            <div className='mt-10'>

                                <EmptyPage title={"No results found"} subtitle={"Try searching for another scene"} /> :

                            </div>}
                        {filteredList.map((scene, index) =>
                            <div key={scene.index} className='flex border-b p-2 gap-4 cursor-pointer justify-between h-full' onClick={() => {
                                setActiveScene(scene)
                                setActiveIndex(scene.index)
                            }}>
                            <div className='flex gap-4'>
                                <div style={{ background: scene.color || timeColors[getTitle(scene.title).time] || '#d9dee3' }} className='w-1 rounded-full' />
                                <div className='py-2'>
                                    <div className='flex items-center gap-1 uppercase text-[15px] font-medium'>
                                        <b>#{scene.index}.</b>
                                        <label className='cursor-pointer max-w-[calc(100svw-150px)] truncate text-nowrap text-[#404040] font-medium'>{scene.title}</label>
                                    </div>
                                    {scene.notes > 0 && <div className='flex mt-1 items-center underline gap-2 text-[14px] text-[#868686] font-medium'>
                                        <label>{scene.notes} Notes</label>
                                    </div>}
                                </div>
                            </div>
                            <div className=' self-center text-[#404040] text-[14px] font-medium me-2'>{scene.sceneHeight}</div>

                            </div>)}
                    </div>
                    {activeScene && <SceneDetailsSlider setUpdateData={setUpdateData} activeScene={activeScene} setActiveScene={setActiveScene} index={activeIndex} scenes={scenes} body={body} scriptData={scriptData} permissionToEdit={permissionToEdit} />}
                </>}
        </>
    )
}

export default ScenesTab